var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-chat-booking float-left ml-3" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "mb-3" }, [
        _c("b", [_vm._v(_vm._s(_vm.message.text))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.otp,
              expression: "otp"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            }
          ],
          staticClass: "form-control",
          class: { "form-alert": _vm.errors.has("otp") },
          attrs: { name: "otp", type: "text", placeholder: "OTP" },
          domProps: { value: _vm.otp },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.otp = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("otp"),
                expression: "errors.has('otp')"
              }
            ],
            staticClass: "help text-danger"
          },
          [_vm._v(_vm._s(_vm.errors.first("otp")))]
        )
      ]),
      _vm._v(" "),
      !_vm.saveSuccess
        ? _c("div", { staticClass: "form-group" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-block btn-info",
                attrs: { disabled: _vm.loading },
                on: { click: _vm.submit }
              },
              [_vm._v("ยืนยัน")]
            ),
            _vm._v(" "),
            _vm.failureCode
              ? _c("div", { staticClass: "text-center mt-4" }, [
                  _c("h3", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.getErrorMessage(_vm.failureCode)))
                  ]),
                  _vm._v(" "),
                  _vm.failureCode === "expired_otp"
                    ? _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-info btn-block",
                            on: {
                              click: function($event) {
                                return _vm.resendOTP()
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "fal fa-redo" }),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("message.verification.resend_code")
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        : _c("div", { staticClass: "text-center mt-4" }, [_vm._m(0)])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("i", { staticClass: "fas fa-check-circle -status-accepted" }),
      _vm._v(" ยืนยันเบอร์โทรสำเร็จ\n      ")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61488a07", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61488a07","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/OTPMessage.vue
// module id = 2227
// module chunks = 0